/**
 * Resolves the units a metric supports from its `analysisUnits`. Returns `undefined` when the
 * metric declares none — we can't confirm what it supports.
 */
export function resolveMetricUnits(metric: { analysisUnits?: readonly string[] }): readonly string[] | undefined {
  return metric.analysisUnits && metric.analysisUnits.length > 0 ? metric.analysisUnits : undefined;
}
